// extracted by mini-css-extract-plugin
module.exports = {"showMoreContainer":"category_showMoreContainer__2z19a","showMore":"category_showMore__Z5bQM"};